import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { DeleteIcon, EditIcon } from '@chakra-ui/icons';
import {
  Box,
  Button,
  Flex,
  IconButton,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Heading,
  Tr,
  useColorModeValue,
  useToast,
  useDisclosure,
  Text,
  Checkbox,
  SimpleGrid,
  grid,
  Tooltip,
} from '@chakra-ui/react';
import Card from 'components/card/Card';
import Default from 'components/fields/InputField';
import { v4 as uuidv4 } from 'uuid';
import { HSeparator } from 'components/separator/Separator';
import InterfaceSelect from 'components/select';
import GlobalAlertDialog from 'components/GlobalAlertDialog';
import GlobalModal from 'components/GlobalModal';
import AssetParamDialog from '../configure/modal/assetParam';
import TableSkeleton from '../configure/components/tableSkeleton';
import { m } from 'framer-motion';
import apiUrls from '../../../api/apiUrls'; // added import
import axiosInstance from '../../../api/axiosInstance';
import { use, useCallback, useEffect, useState } from 'react';
import Sidebar from 'components/sidebar/Sidebar';
import ThresholdModal from '../thresholds/modal/ThresholdModal';
import BreadCrumb from 'components/breadCrumb/BreadCrumb';
import axios from 'axios';

const PLATFORM_ID = process.env.REACT_APP_PLATFORM_ID;

// Device type mappings (display names for select, numbers for payload)
const deviceTypeDisplayMap = { 1: 'MINI', 2: 'GRIDX', 3: 'MINI SECURE' };
const deviceTypeReverseMap = { MINI: 1, GRIDX: 2, 'MINI SECURE': 3 };

const AddConfiguration = () => {
  const breadcrumbItems = [
    { label: 'Home', path: '/dashboard' },
    { label: 'Add Configurations', path: '' },
  ];
  const deviceId = localStorage.getItem('deviceId');

  const toast = useToast();
  const cardBg = useColorModeValue('white', 'navy.700');
  const textColor = useColorModeValue('navy.700', 'white');
  const inputBg = useColorModeValue('white', 'navy.600');
  const navigate = useNavigate();
  const location = useLocation();

  const [configName, setConfigName] = useState('');
  const [selectedDevices, setSelectedDevices] = useState([]);
  const [gridx_type, setGridx_type] = useState('GRIDX');
  const [serialNumber, setSerialNumber] = useState('');
  const {
    isOpen: isOpenSaveConf,
    onOpen: DeviceSaveConf,
    onClose: onCloseSaveConf,
  } = useDisclosure();

  // Add new state for Create New Configuration modal
  const {
    isOpen: isOpenCreateNew,
    onOpen: onOpenCreateNew,
    onClose: onCloseCreateNew,
  } = useDisclosure();

  const [configurations, setConfigurations] = useState([
    {
      id: uuidv4(),
      name: '',
      slaveid: '',
      slaveip: '',
      interface_id: 0,
      parameters: [],
    },
  ]);
  const [originalData, setOriginalData] = useState({});
  const [currentSlaveId, setCurrentSlaveId] = useState(null);
  const [open, setOpen] = useState(false);
  const [openAssetMastermodel, setAssetMasterOpen] = useState(false);
  const [deviceType, setDeviceType] = useState(1);
  const [maxSlavePerDevice, setMaxSlavePerDevice] = useState(128);
  const [maxSlavePerInterFace, setMaxSlavePerInterFace] = useState(32);
  const [maxSlaveParameters, setMaxSlaveParameters] = useState(1000);
  const [loadingDevices, setLoadingDevices] = useState(false);
  const [devicesArray, setDevicesArray] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [hasNext, setHasNext] = useState(true);
  const [loading, setLoading] = useState(false);
  const [collapsed, setCollapsed] = useState(() => {
    const saved = localStorage.getItem('sidebarCollapsed');
    return saved ? JSON.parse(saved) : false;
  });
  const [interfaceDetailsMap, setInterfaceDetailsMap] = useState({});

  const sidebarExpandedWidth = '260px';
  const sidebarCollapsedWidth = '80px';
  const sidebarWidth = collapsed ? sidebarCollapsedWidth : sidebarExpandedWidth;
  const [thresholdModalOpen, setThresholdModalOpen] = useState(false);
  const [selectedThresholdParam, setSelectedThresholdParam] = useState(null);
  const [maxThreshold, setMaxThreshold] = useState('');
  const [minThreshold, setMinThreshold] = useState('');
  const [deviceTypeKey, setDeviceTypeKey] = useState(2);
  const [invalidSlaveIds, setInvalidSlaveIds] = useState({});
  const [interfaceList, setInterfaceList] = useState([]);
  const [pendingSaveAction, setPendingSaveAction] = useState(null);
  // Add these state variables with the others at the top
  const [totalPages, setTotalPages] = useState(0);
  const [totalInterfaces, setTotalInterfaces] = useState(0);
  const isSlaveChanged = (slave) => {
    const original = originalData[slave.id];
    return JSON.stringify(slave) !== JSON.stringify(original);
  };

  const writeFunctionCodes = {
    'Read Only': -1,
    'Write Coil': 5,
    '6 Label': 6,
    '16 Label': 16,
  };

  const ParamTypes = {
    '32bit float': 3,
    '32bit uint': 2,
    '32bit int': 18,
    Str: 42,
    '16bit float': 26,
    '16bit int': 14,
    '16bit uint': 1,
    Bool: 43,
  };

  const RegisterDataType = {
    DCBA: 1,
    BADC: 3,
    Bool: 2,
  };

  const Actions = {
    'Read Only': 0,
    'Read Write': 1,
  };

  // Validation errors will be shown as toast, not modal
  const [interfaceIdMap, setInterfaceIdMap] = useState({});
  const [modbusConfigMap, setmodbusConfigMap] = useState({});
  const [interfaceNumberMap, setInterfaceNumberMap] = useState({});
  const [selectedModbusConfigId, setSelectedModbusConfigId] = useState('');
  const groupID = localStorage.getItem('groupID');

  const showError = (message) => {
    toast({
      title: 'Validation Error',
      description: message,
      status: 'error',
      duration: 3000,
      position: 'top',
      isClosable: true,
    });
  };
  useEffect(() => {
    localStorage.setItem('sidebarCollapsed', JSON.stringify(collapsed));
  }, [collapsed]);
  const confirmDelete = (type, slaveId, paramId = null) => {
    setDeleteTarget({ type, slaveId, paramId });
    setIsDeleteOpen(true);
  };

  const defaultParameter = {
    id: uuidv4(),
    name: '',
    fn_code: 3,
    address: 0,
    type: 43,
    factor: 1,
    register_count: 1,
    register_data_type: 1,
    offset: 0,
    write_fn_code: -1,
    access: 0,
  };

  const handleDeleteConfirmed = () => {
    if (deleteTarget.type === 'slave') {
      setConfigurations((prev) =>
        prev.filter((slave) => slave.id !== deleteTarget.slaveId),
      );
    } else if (deleteTarget.type === 'parameter') {
      setConfigurations((prev) =>
        prev.map((slave) => {
          if (slave.id !== deleteTarget.slaveId) return slave;
          return {
            ...slave,
            parameters: slave.parameters.filter(
              (param) => param.id !== deleteTarget.paramId,
            ),
          };
        }),
      );
    }
    setIsDeleteOpen(false);
    setDeleteTarget({ type: null, slaveId: null, paramId: null });
  };

  // New state for interface change confirmation
  const [pendingInterfaceChange, setPendingInterfaceChange] = useState({
    slaveId: null,
    newInterfaceId: null,
  });
  const [isInterfaceChangeDialogOpen, setIsInterfaceChangeDialogOpen] =
    useState(false);

  const updateSlave = (id, field, value) => {
    if (field === 'interface_id') {
      const slaveIndex = configurations.findIndex((slave) => slave.id === id);
      const currentSlave = configurations[slaveIndex];

      if (slaveIndex === 0) {
        setConfigurations((prev) =>
          prev.map((slave) =>
            slave.id === id
              ? {
                  ...slave,
                  [field]: value,
                  ...(field === 'interface_id' && {
                    interface_uuid: interfaceDetailsMap[value] || '',
                  }),
                }
              : slave,
          ),
        );
        return;
      }

      if (
        currentSlave &&
        currentSlave.interface_id &&
        currentSlave.interface_id !== 0
      ) {
        setPendingInterfaceChange({ slaveId: id, newInterfaceId: value });
        setIsInterfaceChangeDialogOpen(true);
        return;
      }
    }
    setConfigurations((prev) =>
      prev.map((slave) =>
        slave.id === id
          ? {
              ...slave,
              [field]: value,
              ...(field === 'interface_id' && {
                interface_uuid: interfaceDetailsMap[value] || '',
              }),
            }
          : slave,
      ),
    );
  };

  // Handler for confirming interface change
  const handleConfirmInterfaceChange = () => {
    const { slaveId, newInterfaceId } = pendingInterfaceChange;
    setConfigurations((prev) =>
      prev.map((slave) =>
        slave.id === slaveId
          ? {
              ...slave,
              interface_id: newInterfaceId,
              interface_uuid: interfaceDetailsMap[newInterfaceId] || '',
            }
          : slave,
      ),
    );
    setIsInterfaceChangeDialogOpen(false);
    setPendingInterfaceChange({ slaveId: null, newInterfaceId: null });
  };

  // Handler for cancelling interface change
  const handleCancelInterfaceChange = () => {
    setIsInterfaceChangeDialogOpen(false);
    setPendingInterfaceChange({ slaveId: null, newInterfaceId: null });
  };

  // Pagination state: track current page per slave
  const [paramPages, setParamPages] = useState({});

  // Helper: get paginated parameters for a slave
  const getPaginatedParameters = (slave) => {
    const page = paramPages[slave.id] || 0;
    const pageSize = 10;
    const start = page * pageSize;
    const end = start + pageSize;
    return slave.parameters.slice(start, end);
  };

  // Helper: total pages for a slave
  const getTotalPages = (slave) => {
    return Math.ceil((slave.parameters?.length || 0) / 10);
  };

  // Handler: change page for a slave
  const handleParamPageChange = (slaveId, newPage) => {
    setParamPages((prev) => ({
      ...prev,
      [slaveId]: newPage,
    }));
  };

  const generateUniqueParamName = (slaveId, paramId, desiredName) => {
    if (!desiredName || !desiredName.trim()) return desiredName;

    const trimmedName = desiredName.trim();

    const allOtherParams = configurations
      .flatMap((slave) =>
        slave.id === slaveId
          ? slave.parameters
              .filter((p) => p.id !== paramId)
              .map((p) => p.name?.trim())
          : slave.parameters.map((p) => p.name?.trim()),
      )
      .filter(Boolean);

    if (!allOtherParams.includes(trimmedName)) {
      return desiredName;
    }

    let maxSuffix = 0;
    const baseNamePattern = new RegExp(`^${trimmedName}(?:_(\\d+))?$`);

    allOtherParams.forEach((existingName) => {
      const match = existingName.match(baseNamePattern);
      if (match) {
        const suffix = match[1] ? parseInt(match[1], 10) : 0;
        maxSuffix = Math.max(maxSuffix, suffix);
      }
    });

    return `${trimmedName}_${maxSuffix + 1}`;
  };

  const addParameter = (slaveId) => {
    const targetSlave = configurations.find((s) => s.id === slaveId);
    if (!targetSlave) return;

    // Check against max_modbus_params_per_slave
    if (targetSlave.parameters.length >= Number(maxSlaveParameters)) {
      toast({
        title: 'Limit Exceeded',
        description: `You cannot add more than ${maxSlaveParameters} parameters per slave.`,
        status: 'error',
        duration: 3000,
        position: 'top',
        isClosable: true,
      });
      return;
    }

    // Create new parameter with unique name if defaultParameter has a name
    let paramName = defaultParameter.name;
    if (paramName && paramName.trim()) {
      paramName = generateUniqueParamName(slaveId, null, paramName);
    }

    const param = {
      ...defaultParameter,
      id: uuidv4(),
      name: paramName, // Use potentially modified name
    };

    setConfigurations((prev) =>
      prev.map((slave) =>
        slave.id === slaveId
          ? { ...slave, parameters: [...slave.parameters, param] }
          : slave,
      ),
    );

    // Go to last page after adding parameter
    setParamPages((prev) => {
      const newParamCount = (targetSlave.parameters.length || 0) + 1;
      const lastPage = Math.floor((newParamCount - 1) / 10);
      return { ...prev, [slaveId]: lastPage };
    });
  };
  const updateParameter = (slaveId, paramId, field, value, isFinal = false) => {
    if (field === 'name' && value && !/^[A-Za-z]/.test(value.trim())) {
      toast({
        title: 'Invalid Parameter Name',
        description:
          'The first letter of the parameter name must be an alphabet.',
        status: 'error',
        duration: 3000,
        position: 'top',
        isClosable: true,
      });
      return;
    }

    const numericFields = [
      'fn_code',
      'address',
      'factor',
      'register_count',
      'offset',
    ];
    if (numericFields.includes(field) && Number(value) < 0) {
      toast({
        title: 'Invalid Value',
        description: `${field.replace('_', ' ')} cannot be negative.`,
        status: 'error',
        duration: 3000,
        position: 'top',
        isClosable: true,
      });
      return;
    }

    setConfigurations((prev) =>
      prev.map((slave) => {
        if (slave.id !== slaveId) return slave;
        return {
          ...slave,
          parameters: slave.parameters.map((param) => {
            if (param.id !== paramId) return param;

            // If this is the final update for the name field
            if (field === 'name' && isFinal && value && value.trim()) {
              const uniqueName = generateUniqueParamName(
                slaveId,
                paramId,
                value,
              );
              return { ...param, [field]: uniqueName };
            }

            // Regular update (while typing)
            return { ...param, [field]: value };
          }),
        };
      }),
    );
  };

  const [deleteTarget, setDeleteTarget] = useState({
    type: null,
    slaveId: null,
    paramId: null,
  });
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);

  const handleSave = (slave) => {
    const interfaceName = getInterfaceNameById(slave.interface_id);
    if (interfaceName === 'Modbus_TCP') {
      if (!slave.slaveip || !slave.slaveip.trim()) {
        toast({
          title: 'Validation Error',
          description: 'Slave IP is required for Modbus_TCP interface.',
          status: 'error',
          duration: 3000,
          position: 'top',
          isClosable: true,
        });
        return;
      }
      if (!isValidIP(slave.slaveip.trim())) {
        toast({
          title: 'Invalid IP Address',
          description:
            'Please enter a valid IPv4 or IPv6 address for Slave IP.',
          status: 'error',
          duration: 3000,
          position: 'top',
          isClosable: true,
        });
        return;
      }
    }
    if (!isSlaveConfigValid(slave)) {
      toast({
        title: 'Validation Error',
        description:
          'Please fill all required fields (slave name, slave id, interface, and parameter names).',
        status: 'error',
        duration: 3000,
        position: 'top',
        isClosable: true,
      });
      return;
    }
    // const paramNames = new Set();
    // let duplicateParamName = '';
    // for (const param of slave.parameters || []) {
    //   const trimmedParamName = (param.name || '').trim().toLowerCase();
    //   if (trimmedParamName) {
    //     if (paramNames.has(trimmedParamName)) {
    //       duplicateParamName = trimmedParamName;
    //       break;
    //     }
    //     paramNames.add(trimmedParamName);
    //   }
    // }
    // if (duplicateParamName) {
    //   const nameCounts = {};
    //   (slave.parameters || []).forEach((param) => {
    //     const key = (param.name || '').trim().toLowerCase();
    //     if (key) nameCounts[key] = (nameCounts[key] || 0) + 1;
    //   });
    //   const duplicates = Object.entries(nameCounts)
    //     .filter(([_, count]) => count > 1)
    //     .map(([name]) => name)
    //     .join(', ');
    //   toast({
    //     title: 'Duplicate Parameter Name',
    //     description: `Parameter names must be unique within a slave. Duplicate: ${duplicates}`,
    //     status: 'error',
    //     duration: 3000,
    //     position: 'top',
    //     isClosable: true,
    //   });
    //   return;
    // }

    setConfigurations((prev) => {
      const index = prev.findIndex((s) => s.id === slave.id);
      const existingSlave = prev[index];

      let newVersion = 1;

      if (existingSlave) {
        const { version = 1 } = existingSlave;
        newVersion = version + 1;
      }

      const updatedSlave = {
        ...existingSlave,
        version: newVersion,
      };

      toast({
        title: 'Slave Saved.',
        status: 'success',
        duration: 2000,
        position: 'top',
        isClosable: true,
      });

      setOriginalData((prevOriginal) => ({
        ...prevOriginal,
        [slave.id]: updatedSlave,
      }));

      if (index !== -1) {
        const updated = [...prev];
        updated[index] = updatedSlave;
        return updated;
      } else {
        return [...prev, updatedSlave];
      }
    });
  };

  // Add state for device type key (number)

  // Helper: get display name for current deviceTypeKey
  const getDeviceTypeDisplay = (key) => deviceTypeDisplayMap[key] || '';

  const handleDeviceTypeChange = (val) => {
    const num = deviceTypeReverseMap[val];
    if (num) {
      setDeviceTypeKey(num);

      const allowedInterfaces = getFilteredInterfaces(num);
      const allowedIds = allowedInterfaces.map((iface) => iface.interface);

      setConfigurations((prev) =>
        prev.map((slave) => {
          if (!allowedIds.includes(slave.interface_id)) {
            return { ...slave, interface_id: allowedIds[0] || 0 };
          }
          return slave;
        }),
      );
    }
  };
  // Show all columns logic (same as SlaveConfigurations.jsx)
  const showAllColumns = deviceTypeKey === 2;

  const handleSaveConfigurations = async (saveAction) => {
    try {
      const modbusConfig = {
        config_name: configName,
        gridx_type: gridx_type || 'GRIDX',
        config_device_type: deviceTypeKey,
        apply_to_devices: saveAction === 'publish' ? 1 : 0,
        slaves_config: configurations.map((slave) => {
          // Clean parameters based on deviceTypeKey
          const cleanedParameters = slave.parameters.map((param) => {
            const { id, ...restWithoutId } = param;
            const thresholds = param.thresholds || [];

            if (deviceTypeKey === 2) {
              // For GRIDX, send as 'action' field
              const { access, ...rest } = restWithoutId;
              console.log(
                `[cleanedParameters] deviceTypeKey=2, param.name=${param.name}, setting action=${access || 0}`,
              );
              return {
                ...rest,
                action: access || 0, // Map access to action
                thresholds,
              };
            } else {
              // For other types, send as 'access' field
              const { action, ...rest } = restWithoutId;
              console.log(
                `[cleanedParameters] deviceTypeKey!=2, param.name=${param.name}, setting access=${param.access || 0}`,
              );
              return {
                ...rest,
                access: param.access || 0, // Keep as access
                thresholds,
              };
            }
          });

          return {
            apply_to_devices: saveAction === 'publish' ? 1 : 0,
            interface_id: slave?.interface_id || '',
            id: slave?.id || '',
            version: slave?.version ? slave.version : 1,
            slave_id: slave?.slaveid || '',
            slave_ip: slave?.slaveip || '',
            slave_name: slave?.name || '',
            parameters: cleanedParameters,
          };
        }),
      };

      const response = await axiosInstance.post(
        apiUrls.updateConfig(PLATFORM_ID, groupID),
        modbusConfig,
      );

      if (response.status === 200) {
        toast({
          title:
            saveAction === 'publish'
              ? 'Config Published Successfully'
              : 'Config Saved as Draft',
          description: `Config "${configName}" ${saveAction === 'publish' ? 'published' : 'saved as draft'}.`,
          status: 'success',
          duration: 3000,
          position: 'top',
          isClosable: true,
        });

        onCloseSaveConf();
        setConfigName('');
        setPendingSaveAction(null);
        navigate('/modbus-configs');
      } else {
        throw new Error('Unexpected response status');
      }
    } catch (err) {
      console.error('Save failed:', err);
      toast({
        title: 'Save Failed',
        description:
          err.response?.data?.error ||
          'Could not prepare or post the configurations.',
        status: 'error',
        position: 'top',
        duration: 3000,
        isClosable: true,
      });
    }
  };
  const handleCheckboxChange = (id) => {
    setSelectedDevices((prev) =>
      prev.includes(id) ? prev.filter((d) => d !== id) : [...prev, id],
    );
  };

  const updateSlaveParams = (parameters) => {
    if (!currentSlaveId || !parameters || !Array.isArray(parameters)) {
      console.error('Invalid parameters or no slave selected');
      return;
    }

    setConfigurations((prev) =>
      prev.map((slave) => {
        if (slave.id === currentSlaveId) {
          const newParameters = parameters.map((param) => {
            const uniqueName = generateUniqueParamName(
              currentSlaveId,
              null,
              param.name,
            );
            return {
              id: param.id || uuidv4(),
              name: uniqueName,
              fn_code: param.fnCode || 3,
              address: param.address || 0,
              type: ParamTypes[param.type] || 43,
              factor: param.factor || 1,
              register_count: param.regCount || 1,
              register_data_type: RegisterDataType[param.regDataType] || 1,
              offset: param.offset || 0,
              write_fn_code: writeFunctionCodes[param.writeFn] || -1,
              access: Actions[param.access] || 0,
              fromAssetParamDialog: true,
            };
          });

          return {
            ...slave,
            parameters: [...slave.parameters, ...newParameters],
          };
        }
        return slave;
      }),
    );
  };

  const closeAssetParameterModal = () => {
    setAssetMasterOpen(false);
  };

  const areAllConfigurationsSaved = () => {
    return configurations.every((slave) => !isSlaveChanged(slave));
  };

  // Modified onOpenSaveConf function
  // Modified onOpenSaveConf function
  const handleSaveConfigurationClick = (action) => {
    if (configurations.length === 0) {
      toast({
        title: 'No Configurations',
        description:
          'Please add at least one slave configuration before saving.',
        status: 'warning',
        duration: 3000,
        position: 'top',
        isClosable: true,
      });
      return;
    }

    if (!areAllConfigurationsSaved()) {
      toast({
        title: 'Unsaved Changes',
        description:
          'Please save all slave configurations before saving the main configuration.',
        status: 'error',
        duration: 3000,
        position: 'top',
        isClosable: true,
      });
      return;
    }

    setSelectedDevices([]);

    if (action === 'publish') {
      setPendingSaveAction('publish');
      DeviceSaveConf(); // Open modal for publish
    } else if (action === 'draft') {
      // Directly save as draft without opening modal if config name is already set
      if (configName) {
        handleSaveConfigurations('draft');
      } else {
        // If no config name, open modal and set flag for draft
        setPendingSaveAction('draft');
        DeviceSaveConf();
      }
    }
  };
  // Add function to handle create new configuration
  const handleCreateNewConfiguration = () => {
    // Reset to single default slave configuration
    const newSlave = {
      id: uuidv4(),
      name: '',
      slaveid: '',
      slaveip: '',
      interface_id: 0,
      parameters: [],
    };

    setConfigurations([newSlave]);
    setOriginalData({ [newSlave.id]: newSlave });
    setConfigName('');
    setSelectedDevices([]);
    setGridx_type('GRIDX');
    setCurrentSlaveId(null);

    toast({
      title: 'New Configuration Started',
      description: 'Ready to create a new configuration.',
      status: 'info',
      duration: 2000,
      position: 'top',
      isClosable: true,
    });

    onCloseCreateNew();
  };

  // Add API calls to fetch device data
  // const fetchDeviceInterfaces = useCallback(async () => {
  //   try {
  //     const keys = 'interfaces';
  //     const resp = await axiosInstance.get(
  //       apiUrls.fetchModbusConfigsandpatches(PLATFORM_ID, groupID, keys),
  //     );
  //     // In fetchDeviceInterfaces, build a map for details:
  //     const interfaces = resp.data?.interfaces || [];
  //     setInterfaceList(interfaces);
  //     const interfaceIdMap = interfaces.reduce((acc, i) => {
  //       acc[i.name] = i.id;
  //       return acc;
  //     }, {});
  //     const interfaceDetailsMap = interfaces.reduce((acc, i) => {
  //       acc[i.id] = i.interface; // maps id to interface uuid
  //       return acc;
  //     }, {});
  //     setInterfaceIdMap(interfaceIdMap);
  //     setInterfaceDetailsMap(interfaceDetailsMap);
  //     setmodbusConfigMap({}); // No modbus_configs in new response
  //   } catch (err) {
  //     console.error('Failed to fetch device interfaces', err);
  //     toast({
  //       title: 'Error',
  //       description: 'Failed to fetch device interfaces',
  //       status: 'error',
  //       duration: 3000,
  //       position: 'top',
  //       isClosable: true,
  //     });
  //   } finally {
  //     setLoading(false); // <-- ensure loading is reset
  //   }
  // }, [PLATFORM_ID, groupID, toast]);

  const fetchDeviceInterfaces = useCallback(
    async (searchTerm = '', page = 0) => {
      setLoading(true);
      try {
        const response = await axiosInstance.get(
          apiUrls.fetchAllInterfaces(PLATFORM_ID, groupID, searchTerm, page),
        );

        const interfaces = response.data?.results || [];
        const totalCount = response.data?.count || 0;
        setHasNext(!!response.data?.next);
        setTotalPages(Math.ceil(totalCount / 10)); // Assuming page size is 10

        // Build the maps from the fetched interfaces
        const interfaceIdMap = interfaces.reduce((acc, i) => {
          acc[i.name] = i.id;
          return acc;
        }, {});

        const interfaceDetailsMap = interfaces.reduce((acc, i) => {
          acc[i.interface] = i.interface; // maps interface uuid to itself
          return acc;
        }, {});

        setInterfaceList(interfaces);
        setInterfaceIdMap(interfaceIdMap);
        setInterfaceDetailsMap(interfaceDetailsMap);
      } catch (err) {
        console.error('Failed to fetch interfaces', err);
        toast({
          title: 'Error',
          description: 'Failed to fetch interfaces',
          status: 'error',
          duration: 3000,
          position: 'top',
          isClosable: true,
        });
      } finally {
        setLoading(false);
      }
    },
    [PLATFORM_ID, groupID, toast],
  );

  useEffect(() => {
    fetchDeviceInterfaces();
  }, [PLATFORM_ID, groupID]);

  // Add useEffect to fetch data on component mount
  useEffect(() => {
    setLoading(true);
    fetchDeviceInterfaces();
  }, [fetchDeviceInterfaces]);

  function isValidIPv4(ip) {
    return /^((25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.|$)){4}$/.test(ip);
  }

  function isValidIPv6(ip) {
    return /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::1)$|^(([0-9a-fA-F]{1,4}:){1,7}:)$|^(:{2}([0-9a-fA-F]{1,4}:){0,5}[0-9a-fA-F]{1,4})$/.test(
      ip,
    );
  }

  function isValidIP(ip) {
    return isValidIPv4(ip) || isValidIPv6(ip);
  }

  const isSlaveConfigValid = (slave) => {
    if (!slave.name || !slave.name.trim()) return false;
    if (!slave.slaveid || slave.slaveid === '') return false;
    if (!slave.interface_id || slave.interface_id === 0) return false;
    const interfaceName = getInterfaceNameById(slave.interface_id);
    if (interfaceName === 'Modbus_TCP') {
      if (!slave.slaveip || !slave.slaveip.trim()) return false;
      if (!isValidIP(slave.slaveip.trim())) return false;
    }
    if (slave.parameters.some((param) => !param.name || !param.name.trim()))
      return false;
    return true;
  };
  // Helper to get interface name by interface_id
  const getInterfaceNameById = (interface_id) => {
    const iface = interfaceList.find((i) => i.interface === interface_id);
    return iface ? iface.name : '';
  };

  // Modified addSlave to copy interface_id from last slave
  const addSlave = () => {
    // Check against maxSlavePerDevice
    if (configurations.length >= Number(maxSlavePerDevice)) {
      toast({
        title: 'Limit Exceeded',
        description: `You cannot add more than ${maxSlavePerDevice} slaves.`,
        status: 'error',
        duration: 3000,
        position: 'top',
        isClosable: true,
      });
      return;
    }

    const trimmedNames = configurations
      .map((s) => (s.name || '').trim().toLowerCase())
      .filter((n) => n);

    const lastSlave = configurations[configurations.length - 1];
    const newSlave = {
      id: uuidv4(),
      name: '',
      slaveid: '',
      slaveip: '',
      interface_id: lastSlave ? lastSlave.interface_id : 0,
      interface_uuid: lastSlave
        ? interfaceDetailsMap[lastSlave.interface_id] || ''
        : '',

      parameters: [],
    };

    setConfigurations((prev) => [...prev, newSlave]);
    setOriginalData((prev) => ({ ...prev, [newSlave.id]: newSlave }));
  };

  const handleOpenThresholdModal = (slave, param) => {
    setSelectedThresholdParam({ slave, param });
    setMinThreshold(param.thresholds?.[0]?.min || '');
    setMaxThreshold(param.thresholds?.[0]?.max || '');
    setThresholdModalOpen(true);
  };
  const handleAddThreshold = () => {
    if (!selectedThresholdParam) return;

    const min = Number(minThreshold);
    const max = Number(maxThreshold);

    if (isNaN(min) || isNaN(max)) {
      toast({
        title: 'Invalid Threshold',
        description: 'Both min and max thresholds must be valid numbers.',
        status: 'error',
        duration: 3000,
        position: 'top',
        isClosable: true,
      });
      return;
    }
    if (min >= max) {
      toast({
        title: 'Invalid Threshold',
        description: 'Min threshold must be less than Max threshold.',
        status: 'error',
        duration: 3000,
        position: 'top',
        isClosable: true,
      });
      return;
    }

    const { slave, param } = selectedThresholdParam;
    setConfigurations((prev) =>
      prev.map((s) =>
        s.id === slave.id
          ? {
              ...s,
              parameters: s.parameters.map((p) =>
                p.id === param.id
                  ? {
                      ...p,
                      thresholds: [
                        {
                          min: minThreshold,
                          max: maxThreshold,
                        },
                      ],
                    }
                  : p,
              ),
            }
          : s,
      ),
    );
    setThresholdModalOpen(false);
  };
  const getFilteredInterfaces = (type = deviceTypeKey) => {
    if (type === 1 || type === 3) {
      return interfaceList.filter(
        (iface) =>
          iface.name === 'Modbus_RS485_1' || iface.name === 'Modbus_TCP',
      );
    }
    return interfaceList;
  };
  return (
    <>
      {loading ? (
        <TableSkeleton rowCount={5} columnCount={12} />
      ) : (
        <Box mt={6} ml={1} color={textColor} pb={32}>
          <BreadCrumb items={breadcrumbItems} sidebarWidth={sidebarWidth} />

          <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />

          <Flex
            ml={sidebarWidth}
            justify="space-between"
            mt={1}
            mr={5}
            align="center"
            gap={2}
          >
            <Heading size="lg" mb={6} ml={2}>
              Add Configuration
            </Heading>
            {Object.keys(modbusConfigMap).length > 0 && (
              <Box>
                {/* <Flex>
                  <Text me="3" mt={1} fontWeight="600">
                    Config:
                  </Text>
                  <InterfaceSelect
                    value={selectedModbusConfigId}
                    options={modbusConfigMap}
                    onChange={(selectedConfig) =>
                      setSelectedModbusConfigId(selectedConfig)
                    }
                  />
                </Flex> */}
              </Box>
            )}
            <Flex align="center" gap={2}>
              <Text mr={2} fontWeight="600">
                Device Type
              </Text>
              <Flex align={'center'} gap={2}>
                <InterfaceSelect
                  value={getDeviceTypeDisplay(deviceTypeKey)}
                  options={Object.keys(deviceTypeReverseMap)}
                  onChange={handleDeviceTypeChange}
                />
                <Flex align="center" gap={2}>
                  <Button
                    size="sm"
                    colorScheme="blue"
                    variant="outline"
                    border="2px"
                    cursor="pointer"
                    onClick={() => handleSaveConfigurationClick('publish')}
                  >
                    Publish
                  </Button>
                  <Button
                    size="sm"
                    colorScheme="blue"
                    variant="outline"
                    border="2px"
                    cursor="pointer"
                    onClick={() => handleSaveConfigurationClick('draft')}
                  >
                    Save as Draft
                  </Button>

                  <Button
                    size="sm"
                    colorScheme="green"
                    variant="outline"
                    border="2px"
                    cursor="pointer"
                    onClick={onOpenCreateNew}
                  >
                    Add New
                  </Button>
                </Flex>
              </Flex>
            </Flex>
          </Flex>

          {configurations.map((slave) => {
            const interfaceName = getInterfaceNameById(slave.interface_id);
            const isModbusTCP = interfaceName === 'Modbus_TCP';
            return (
              <Card
                ml={sidebarWidth}
                width={`calc(100% - ${sidebarWidth} - 20px)`}
                mr="32px"
                key={slave.id}
                bg={cardBg}
                p={4}
                my={4}
                color={textColor}
              >
                <Table size="sm" mb={4}>
                  <Thead>
                    <Tr>
                      <Th borderColor="transparent">Name</Th>
                      <Th borderColor="transparent">Slave ID</Th>
                      {isModbusTCP && (
                        <>
                          <Th borderColor="transparent">Slave IP</Th>
                          {/* <Th borderColor="transparent">Slave Port</Th> */}
                        </>
                      )}
                      <Th borderColor="transparent">Interface</Th>
                      <Th borderColor="transparent" textAlign="center">
                        Actions
                      </Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    <Tr>
                      <Td borderColor="transparent" ps={0}>
                        <Default
                          size="sm"
                          fontSize="lg"
                          placeholder="slave name"
                          value={slave.name}
                          onChange={(e) =>
                            updateSlave(slave.id, 'name', e.target.value)
                          }
                          bg={inputBg}
                          color={textColor}
                        />
                      </Td>
                      <Td borderColor="transparent" ps={0}>
                        <Tooltip
                          label="Slave ID must be a positive number greater than 0"
                          isOpen={invalidSlaveIds[slave.id] || false}
                          placement="top"
                          hasArrow
                          bg="red.500"
                          color="white"
                        >
                          <Box>
                            <Default
                              size="sm"
                              fontSize="md"
                              type="number"
                              placeholder="slave id"
                              value={slave.slaveid}
                              onKeyDown={(e) => {
                                if (
                                  ['e', 'E', '+', '-', '.', ' '].includes(e.key)
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              onChange={(e) => {
                                const val = e.target.value;
                                // Allow only digits, no leading zero
                                if (val === '' || /^[1-9][0-9]*$/.test(val)) {
                                  updateSlave(
                                    slave.id,
                                    'slaveid',
                                    val === '' ? '' : Number(val),
                                  );
                                  setInvalidSlaveIds((prev) => ({
                                    ...prev,
                                    [slave.id]: false,
                                  }));
                                } else {
                                  setInvalidSlaveIds((prev) => ({
                                    ...prev,
                                    [slave.id]: true,
                                  }));
                                }
                              }}
                              bg={inputBg}
                              color={textColor}
                            />
                          </Box>
                        </Tooltip>
                      </Td>
                      {isModbusTCP && (
                        <>
                          <Td borderColor="transparent" ps={0}>
                            <Default
                              size="sm"
                              fontSize="md"
                              placeholder="slave ip"
                              value={slave.slaveip}
                              onChange={(e) =>
                                updateSlave(slave.id, 'slaveip', e.target.value)
                              }
                              bg={inputBg}
                              color={textColor}
                            />
                          </Td>
                          {/* <Td borderColor="transparent" ps={0}>
                            <Default
                              size="sm"
                              fontSize="md"
                              placeholder="slave port"
                              value={
                                slave.port === undefined || slave.port === ''
                                  ? ''
                                  : slave.port
                              }
                              onChange={(e) => {
                                const val = e.target.value;
                                updateSlave(
                                  slave.id,
                                  'port',
                                  val === '' ? '' : Number(val),
                                );
                              }}
                              bg={inputBg}
                              color={textColor}
                            />
                          </Td> */}
                        </>
                      )}
                      <Td borderColor="transparent" ps={0}>
                        <InterfaceSelect
                          value={slave.interface_id}
                          options={getFilteredInterfaces().map((iface) => ({
                            label: iface.name,
                            value: iface.interface,
                          }))}
                          onChange={(selectedInterface) => {
                            updateSlave(
                              slave.id,
                              'interface_id',
                              selectedInterface,
                            );
                          }}
                        />
                      </Td>
                      <Td borderColor="transparent" textAlign="center" ps={0}>
                        <IconButton
                          aria-label="Remove slave"
                          icon={<DeleteIcon />}
                          size="sm"
                          colorScheme="red"
                          onClick={() => confirmDelete('slave', slave.id)}
                          mr={2}
                        />
                      </Td>
                    </Tr>
                  </Tbody>
                </Table>

                <HSeparator />

                {slave.parameters.length > 0 && (
                  <Box overflowX="auto" maxWidth="100%">
                    <Table variant="simple" size="sm" mt={4}>
                      <Thead>
                        <Tr>
                          <Th borderColor="transparent">Name</Th>
                          <Th borderColor="transparent">Fn Code</Th>
                          <Th borderColor="transparent">Address</Th>
                          <Th borderColor="transparent">Type</Th>
                          <Th borderColor="transparent">Factor</Th>
                          {showAllColumns && (
                            <Th borderColor="transparent">Reg Count</Th>
                          )}
                          {showAllColumns && (
                            <Th borderColor="transparent">
                              Register Data Type
                            </Th>
                          )}
                          {showAllColumns && (
                            <Th borderColor="transparent">Offset</Th>
                          )}
                          {showAllColumns && (
                            <Th borderColor="transparent">Write Fn</Th>
                          )}
                          <Th borderColor="transparent">Access</Th>
                          <Th borderColor="transparent" textAlign="center">
                            Threshold
                          </Th>
                          <Th borderColor="transparent">Delete</Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {getPaginatedParameters(slave).map((param, idx) => (
                          <Tr key={param.id || idx}>
                            <Td ps={0} borderColor="transparent">
                              <Default
                                size="sm"
                                placeholder="e.g. tmp"
                                value={param.name}
                                onChange={(e) =>
                                  updateParameter(
                                    slave.id,
                                    param.id,
                                    'name',
                                    e.target.value,
                                    false, // Not final while typing
                                  )
                                }
                                onBlur={(e) =>
                                  updateParameter(
                                    slave.id,
                                    param.id,
                                    'name',
                                    e.target.value,
                                    true, // Final when focus leaves
                                  )
                                }
                                bg={inputBg}
                                color={textColor}
                                isDisabled={true}
                              />
                            </Td>
                            <Td ps={0} borderColor="transparent">
                              <Default
                                size="sm"
                                type="number"
                                value={param.fn_code}
                                onChange={(e) => {
                                  const val = e.target.value;
                                  updateParameter(
                                    slave.id,
                                    param.id,
                                    'fn_code',
                                    val === '' ? '' : Number(val),
                                  );
                                }}
                                bg={inputBg}
                                color={textColor}
                              />
                            </Td>
                            <Td ps={0} borderColor="transparent">
                              <Default
                                size="sm"
                                type="number"
                                value={param.address}
                                onChange={(e) => {
                                  const val = e.target.value;
                                  updateParameter(
                                    slave.id,
                                    param.id,
                                    'address',
                                    val === '' ? '' : Number(val),
                                  );
                                }}
                                bg={inputBg}
                                color={textColor}
                              />
                            </Td>
                            <Td ps={0} borderColor="transparent">
                              <InterfaceSelect
                                value={param.type}
                                options={ParamTypes}
                                onChange={(val) =>
                                  updateParameter(
                                    slave.id,
                                    param.id,
                                    'type',
                                    val,
                                  )
                                }
                              />
                            </Td>
                            <Td ps={0} borderColor="transparent">
                              <Default
                                size="sm"
                                type="number"
                                value={param.factor}
                                onChange={(e) => {
                                  const val = e.target.value;
                                  updateParameter(
                                    slave.id,
                                    param.id,
                                    'factor',
                                    val === '' ? '' : Number(val),
                                  );
                                }}
                                bg={inputBg}
                                color={textColor}
                              />
                            </Td>
                            {showAllColumns && (
                              <Td ps={0} borderColor="transparent">
                                <Default
                                  size="sm"
                                  type="number"
                                  value={param.register_count}
                                  onChange={(e) => {
                                    const val = e.target.value;
                                    updateParameter(
                                      slave.id,
                                      param.id,
                                      'register_count',
                                      val === '' ? '' : Number(val),
                                    );
                                  }}
                                  bg={inputBg}
                                  color={textColor}
                                />
                              </Td>
                            )}
                            {showAllColumns && (
                              <Td ps={0} borderColor="transparent">
                                <InterfaceSelect
                                  value={param.register_data_type}
                                  options={RegisterDataType}
                                  onChange={(val) =>
                                    updateParameter(
                                      slave.id,
                                      param.id,
                                      'register_data_type',
                                      val,
                                    )
                                  }
                                />
                              </Td>
                            )}
                            {showAllColumns && (
                              <Td ps={0} borderColor="transparent">
                                <Default
                                  size="sm"
                                  type="number"
                                  value={param.offset}
                                  onChange={(e) => {
                                    const val = e.target.value;
                                    updateParameter(
                                      slave.id,
                                      param.id,
                                      'offset',
                                      val === '' ? '' : Number(val),
                                    );
                                  }}
                                  bg={inputBg}
                                  color={textColor}
                                />
                              </Td>
                            )}
                            {showAllColumns && (
                              <Td ps={0} borderColor="transparent">
                                <InterfaceSelect
                                  value={param.write_fn_code}
                                  options={writeFunctionCodes}
                                  onChange={(val) =>
                                    updateParameter(
                                      slave.id,
                                      param.id,
                                      'write_fn_code',
                                      val,
                                    )
                                  }
                                />
                              </Td>
                            )}
                            <Td ps={0} borderColor="transparent">
                              <InterfaceSelect
                                value={param.access || 0}
                                options={Actions}
                                onChange={(val) =>
                                  updateParameter(
                                    slave.id,
                                    param.id,
                                    'access',
                                    val,
                                  )
                                }
                              />
                            </Td>
                            <Td
                              ps={2}
                              pr={2}
                              borderColor="transparent"
                              textAlign="center"
                              minW="120px"
                            >
                              {param.thresholds &&
                              param.thresholds.length > 0 ? (
                                <Flex
                                  align="start"
                                  justify="space-between"
                                  gap={2}
                                >
                                  <Text fontSize="sm" align="start">
                                    <Text as="span" fontWeight="semibold">
                                      Min:
                                    </Text>{' '}
                                    {param.thresholds[0].min}
                                    <br />
                                    <Text as="span" fontWeight="semibold">
                                      Max:
                                    </Text>{' '}
                                    {param.thresholds[0].max}
                                  </Text>
                                  <IconButton
                                    aria-label="Edit Threshold"
                                    icon={
                                      <EditIcon boxSize={4} color="blue.400" />
                                    }
                                    size="xs"
                                    justifyContent="end"
                                    alignItems="center"
                                    variant="ghost"
                                    onClick={() => {
                                      setSelectedThresholdParam({
                                        slave,
                                        param,
                                      });
                                      setMaxThreshold(
                                        param.thresholds?.[0]?.max ?? '',
                                      );
                                      setMinThreshold(
                                        param.thresholds?.[0]?.min ?? '',
                                      );
                                      setThresholdModalOpen(true);
                                    }}
                                  />
                                </Flex>
                              ) : (
                                <Flex
                                  align="start"
                                  justify="space-between"
                                  gap={2}
                                >
                                  <Text fontSize="sm" align="start">
                                    <Text as="span" fontWeight="semibold">
                                      Min:
                                    </Text>{' '}
                                    {'-'}
                                    <br />
                                    <Text as="span" fontWeight="semibold">
                                      Max:
                                    </Text>{' '}
                                    {'-'}
                                  </Text>
                                  <IconButton
                                    aria-label="Edit Threshold"
                                    icon={
                                      <EditIcon boxSize={4} color="blue.400" />
                                    }
                                    size="xs"
                                    justifyContent="end"
                                    alignItems="center"
                                    variant="ghost"
                                    onClick={() => {
                                      setSelectedThresholdParam({
                                        slave,
                                        param,
                                      });
                                      setMaxThreshold(
                                        param.thresholds?.[0]?.max ?? '',
                                      );
                                      setMinThreshold(
                                        param.thresholds?.[0]?.min ?? '',
                                      );
                                      setThresholdModalOpen(true);
                                    }}
                                  />
                                </Flex>
                              )}
                            </Td>
                            <Td
                              ps={0}
                              textAlign="center"
                              borderColor="transparent"
                            >
                              <IconButton
                                icon={<DeleteIcon />}
                                aria-label="Delete parameter"
                                size="sm"
                                colorScheme="red"
                                onClick={() =>
                                  confirmDelete('parameter', slave.id, param.id)
                                }
                              />
                            </Td>
                          </Tr>
                        ))}
                      </Tbody>
                    </Table>
                    {/* Pagination controls per slave */}
                    <Flex justify="space-between" align="center" mt={2}>
                      <Button
                        size="md"
                        onClick={() =>
                          handleParamPageChange(
                            slave.id,
                            Math.max((paramPages[slave.id] || 0) - 1, 0),
                          )
                        }
                        isDisabled={(paramPages[slave.id] || 0) === 0}
                      >
                        {'<'}
                      </Button>
                      <Text fontSize="sm" mx={2}>
                        Page {(paramPages[slave.id] || 0) + 1} of{' '}
                        {getTotalPages(slave)}
                      </Text>
                      <Button
                        size="md"
                        onClick={() =>
                          handleParamPageChange(
                            slave.id,
                            Math.min(
                              (paramPages[slave.id] || 0) + 1,
                              getTotalPages(slave) - 1,
                            ),
                          )
                        }
                        isDisabled={
                          (paramPages[slave.id] || 0) >=
                          getTotalPages(slave) - 1
                        }
                      >
                        {'>'}
                      </Button>
                    </Flex>
                  </Box>
                )}

                <AssetParamDialog
                  open={openAssetMastermodel}
                  onClose={closeAssetParameterModal}
                  updateSlaveParams={updateSlaveParams}
                />

                <Flex justify="center" mt={3} gap={2} align="center">
                  <Button
                    size="sm"
                    colorScheme="green"
                    variant="outline"
                    border="2px"
                    cursor="pointer"
                    onClick={() => handleSave(slave)}
                    isDisabled={!isSlaveChanged(slave)}
                  >
                    Save
                  </Button>
                  {/* <Button
                    size="sm"
                    mx="2"
                    variant="outline"
                    border="2px"
                    colorScheme="orange"
                    cursor="pointer"
                    onClick={() => addParameter(slave.id)}
                  >
                    Add Parameter
                  </Button> */}
                  <Button
                    variant="outline"
                    border="2px"
                    colorScheme="orange"
                    size="sm"
                    cursor="pointer"
                    onClick={() => {
                      setCurrentSlaveId(slave.id);
                      setOpen(true);
                    }}
                  >
                    Add Asset
                  </Button>
                </Flex>
              </Card>
            );
          })}

          <AssetParamDialog
            open={open}
            onClose={() => {
              setOpen(false);
              setCurrentSlaveId(null);
            }}
            updateSlaveParams={updateSlaveParams}
          />

          {/* Add Slave Button (same as SlaveConfigurations.jsx) */}
          <Flex justify="center" mt={6} width="100%">
            <Button
              size="sm"
              variant="outline"
              border="2px"
              colorScheme="orange"
              cursor="pointer"
              ml={200}
              onClick={addSlave}
            >
              Add Slave
            </Button>
          </Flex>

          <GlobalAlertDialog
            isOpen={isDeleteOpen}
            onClose={() => setIsDeleteOpen(false)}
            onConfirm={handleDeleteConfirmed}
            title={
              deleteTarget.type === 'slave'
                ? 'Delete Slave'
                : 'Delete Parameter'
            }
            body={
              <>
                Are you sure you want to delete this{' '}
                {deleteTarget.type === 'slave' ? 'slave' : 'parameter'}? This
                action cannot be undone.
              </>
            }
            confirmText="Delete"
            cancelText="Cancel"
            showCancel={true}
          />

          {/* Validation errors are now shown as toast, not modal */}

          {/* Modified Save Configuration Modal */}
          <GlobalModal
            isOpen={isOpenSaveConf}
            onClose={() => {
              onCloseSaveConf();
              setConfigName('');
            }}
            title="Save Configuration"
            size="md"
            bg={cardBg}
          >
            <Default
              fontSize="lg"
              border="2px"
              mb="4"
              placeholder="Enter Configuration Name"
              value={configName}
              onChange={(e) => setConfigName(e.target.value)}
              bg={inputBg}
              color={textColor}
            />
            {!configName && (
              <Text fontSize="sm" color="red.500" mb={2}>
                Configuration name is required.
              </Text>
            )}

            <Flex justify="center" mt={4} gap={3}>
              <Button
                size="sm"
                colorScheme="green"
                variant="outline"
                border="2px"
                isDisabled={!configName}
                onClick={() => {
                  handleSaveConfigurations(pendingSaveAction || 'publish');
                  onCloseSaveConf();
                }}
                cursor="pointer"
              >
                {pendingSaveAction === 'draft' ? 'Save as Draft' : 'Publish'}
              </Button>
              <Button
                size="sm"
                colorScheme="gray"
                variant="outline"
                border="2px"
                cursor="pointer"
                onClick={() => {
                  onCloseSaveConf();
                  setConfigName('');
                  setPendingSaveAction(null);
                }}
              >
                Cancel
              </Button>
            </Flex>
          </GlobalModal>

          {/* Create New Configuration Confirmation Modal */}
          <GlobalModal
            isOpen={isOpenCreateNew}
            onClose={onCloseCreateNew}
            title="Create New Configuration"
            size="md"
            bg={cardBg}
          >
            <Text mb={4}>
              Are you sure you want to create a new configuration? This will
              clear all current configurations.
            </Text>
            <Flex justify="center" gap={3}>
              <Button
                size="sm"
                colorScheme="green"
                variant="outline"
                border="2px"
                cursor="pointer"
                onClick={handleCreateNewConfiguration}
              >
                Yes, Create New
              </Button>
              <Button
                size="sm"
                colorScheme="gray"
                variant="outline"
                border="2px"
                cursor="pointer"
                onClick={onCloseCreateNew}
              >
                Cancel
              </Button>
            </Flex>
          </GlobalModal>

          {/* Interface Change Confirmation Dialog */}
          <GlobalAlertDialog
            isOpen={isInterfaceChangeDialogOpen}
            onClose={handleCancelInterfaceChange}
            onConfirm={handleConfirmInterfaceChange}
            title="Change Interface"
            body="Are you sure you want to change the interface for this slave?"
            confirmText="Yes"
            cancelText="No"
            showCancel={true}
          />
          <ThresholdModal
            isOpen={thresholdModalOpen}
            onClose={() => setThresholdModalOpen(false)}
            selectedParam={selectedThresholdParam}
            maxThreshold={maxThreshold}
            minThreshold={minThreshold}
            setMaxThreshold={setMaxThreshold}
            setMinThreshold={setMinThreshold}
            onAdd={handleAddThreshold}
          />
        </Box>
      )}
      <Flex
        as="footer"
        position="fixed"
        left={0}
        bottom="0"
        width="100%"
        bg={useColorModeValue('gray.100', 'navy.800')}
        color={useColorModeValue('gray.600', 'gray.200')}
        py={2}
        px={4}
        align="center"
        justify="space-between"
        zIndex={20} // higher than sidebar
        borderTop="1px solid"
        borderColor={useColorModeValue('gray.200', 'gray.700')}
        boxShadow="0 -2px 8px rgba(0,0,0,0.04)"
      >
        <Text fontSize="sm" fontWeight="medium">
          Version 1.0.0
        </Text>
        <Text fontSize="sm" fontWeight="medium">
          UGX Systems
        </Text>
      </Flex>
    </>
  );
};

export default AddConfiguration;
